import { robotAlarmErrorNames, robotAlarmWarningNames } from "@/helpers/constants/Robot";

export function getRobotAlarmErrorNames() {
    return JSON.parse(JSON.stringify(robotAlarmErrorNames));
}

export function getRobotAlarmWarningNames() {
    return JSON.parse(JSON.stringify(robotAlarmWarningNames));
}